// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import {
    mapDispatchToPropsForProductList,
    mapStateToPropsForProductList,
    ProductListPage,
    ProductListPageDataContext,
} from "@keller/Overrides/Pages/ProductListPage";
import * as React from "react";
import { connect } from "react-redux";
import { withCallDeferredApi } from "@insite/client-framework/Components/DeferredApiContext";

export interface PartialProductListStyle {}

const styles: PartialProductListStyle = {};

class PartialProductList extends ProductListPage {
    loadProducts() {
        const { displayProducts, path, search } = this.props;

        displayProducts({
            path,
            queryString: search,
            isSearch: this.isSearchPath(),
            includeProductsInSubCategories: true,
            restrictAttributesToCategory: false,
        } as any);
    }

    render() {
        if (
            this.props.productsDataView.value?.length &&
            this.props.productsDataView.exactMatch &&
            !this.props.stockedItemsOnly
        ) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        return (
            <CategoryContext.Provider value={this.props.category}>
                <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                    <Zone contentId={this.props.id} zoneName="Content" />
                    <Modals />
                    <ProductCompareFlyOut />
                </ProductListPageDataContext.Provider>
            </CategoryContext.Provider>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToPropsForProductList,
        mapDispatchToPropsForProductList,
    )(withCallDeferredApi(withHistory(PartialProductList))),
    definition: {
        allowedContexts: ["CategoryDetailsPage"],
        group: "Categories",
    },
};

export default widgetModule;
